/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React from 'react';
import ClinicDetails from './ClinicForm';
import { useGetClinic } from '../../hooks/clinic/useGetClinic';
import BreadCrumbs from '../core/BreadCrumbs';
import CaseViewLoader from '../core/Loaders/CaseViewLoader';
const BREAD_CRUMBS = [
  { label: 'Clinic', to: '/user/cliniclist' },
  { label: 'Edit', to: '/user/clinic/edit' },
];

const EditClinic = () => {
  const { data, loading: fetchingDetails, getClinic } = useGetClinic();

  return (
    <>
      <BreadCrumbs items={BREAD_CRUMBS} />
      <div className="row card">
        <div className="invoices-tabs-card">
          <div className="card-body">
            {fetchingDetails ? (
              <CaseViewLoader />
            ) : (
              <ClinicDetails data={data} onReload={getClinic}/>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EditClinic;
